import type { User } from '../types';

/**
 * Retrieves a key from the api profile data structure.
 *
 * @param {string} key - key to search in the user api profile
 * @param {User} user - user data
 */
export const retrieveKeyFromApiProfile = (key: string, user: User) => {
    /**
     * We are ignoring this typescript error since TS wants us to use only the possible
     * keys from user.apiProfile.organizations, which seems like an overkill.
     */
    return user.apiProfile?.organizations && user.apiProfile.organizations.length > 0
        ? // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          user.apiProfile.organizations[0][key]
        : undefined;
};
